module.exports = __webpack_public_path__ + "img/YellowRupee.78a23103.svg";